import moment from 'moment';

function compareDates(dateA, dateB) {
	const momentA = moment(dateA);
	const momentB = moment(dateB);

	if (!momentB.isValid() || momentA.isBefore(momentB)) {
		return -1;
	}

	if (!momentA.isValid() || momentA.isAfter(momentB)) {
		return 1;
	}

	return 0;
}

function compareNumbers(numberA, numberB) {
	if (numberB === null || numberB === undefined) {
		return 1;
	}

	if (numberA === null || numberA === undefined) {
		return -1;
	}

	return numberA - numberB;
}

function compareStrings(stringA, stringB) {
	if (stringA > stringB || stringB === null || stringB === undefined) {
		return 1;
	}

	if (stringA < stringB || stringA === null || stringA === undefined) {
		return -1;
	}

	return 0;
}

function compareManyProps(a, b, props, comparator) {
	for (let i = 0; i < props.length; i++) {
		const prop = props[i];
		const result = comparator(a[prop], b[prop]);
		if (result !== 0) {
			return result;
		}
	}

	return 0;
}

// plain functions
export const func = {
	dates: compareDates,
	numbers: compareNumbers,
	strings: compareStrings
};

// fluent API
export function compare(prop) {
	return {
		as: {
			dates: (a, b) => compareDates(a[prop], b[prop]),
			numbers: (a, b) => compareNumbers(a[prop], b[prop]),
			strings: (a, b) => compareStrings(a[prop], b[prop])
		}
	};
}

export function compareMany(...props) {
	return {
		as: {
			dates: (a, b) => compareManyProps(a, b, props, compareDates),
			numbers: (a, b) => compareManyProps(a, b, props, compareNumbers),
			strings: (a, b) => compareManyProps(a, b, props, compareStrings)
		}
	};
}

export default {
	func,
	compare,
	compareMany
};



// WEBPACK FOOTER //
// ./src/shared/utils/sortComparisons.js